module.exports = nps;